import classNames from 'classnames';
import React from 'react';

import {trackEvent} from 'analytics/Analytics';
import {BLAST_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import {ColoringSchemeType} from 'search/blast/ColoringScheme';
import {AaSequenceColoringSchemeOption} from 'search/blast/ColoringSchemeMenuOption';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';
import SectionHeader from 'ui-library/menus/SectionHeader';

export interface ViewMenuProps {
  coloringScheme: ColoringSchemeType;
  setColoringScheme: (scheme: ColoringSchemeType) => void;
}

export default function ViewMenu({coloringScheme, setColoringScheme}: ViewMenuProps): JSX.Element {
  return (
    <Dropdown
      menu={
        <Menu width={MenuWidth.FIT_CONTENT} dropLeft={true}>
          {[
            <SectionHeader key="coloring_scheme_header">COLORING SCHEME</SectionHeader>,
            <Option key="coloring_scheme_option">
              <div className={classNames('u-small-spacing-right')}>
                <AaSequenceColoringSchemeOption coloringScheme={coloringScheme} />
              </div>
              <Menu width={MenuWidth.FIT_CONTENT} dropLeft={false}>
                {Object.values(ColoringSchemeType).map((type) => (
                  <Option
                    key={type}
                    isSelected={coloringScheme === type}
                    onSelect={() => {
                      trackEvent(BLAST_ANALYTICS_ACTIONS.CHANGED_COLORING_SCHEME, {
                        coloringScheme: type,
                      });
                      setColoringScheme(type);
                    }}
                  >
                    <AaSequenceColoringSchemeOption key={`scheme-option-${type}`} coloringScheme={type} />
                  </Option>
                ))}
              </Menu>
            </Option>,
          ]}
        </Menu>
      }
    >
      <Button size={ButtonSize.SMALL} buttonStyle={ButtonStyle.TERTIARY_GRAY} text="View" isDropdown={true} />
    </Dropdown>
  );
}
